import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { Input } from "design-react-kit";
import { Link } from "react-router-dom";
import { TokenContext } from "../../Components/TokenContext";
import EditorJs from "../../Components/Editor";
import Repo from "../../Utility/Repo";
import ModalComponent from "../../Components/ModalComponent";
import Loader from "../../Components/Loader";
import { useCookies } from "react-cookie";
import React, { useContext, useState, useEffect } from "react";

function SubscriptionDetailADI({
  userSubscriptions,
  toggleModalShowFile,
  toggleModalAdd,
  toggleModalAddHours,
  setFile,
  setFileSettings,
  setshowModalModify,
  isOperator,
  isDelegate,
  isExecutive,
  haveIsee,
  setShowModalOtherServices,
}) {
  const [cookies] = useCookies();
  const apiToken = useContext(TokenContext);
  const [dettaglio, setDettaglio] = useState();
  const [fileB64, setFileB64] = useState(false);
  const [showModalFile, setShowModalFile] = useState(false);
  const [showModalConfirm, setShowModalConfirm] = useState(false);
  const [firstTime, setFirstTime] = useState(true);
  const [firstTime2, setFirstTime2] = useState(true);
  const [loading, setLoading] = useState(false);

  const handleSave = (azione) => {
    setLoading(true);
    userSubscriptions.dettagli = dettaglio;
    Repo.postInsertDettaglio(apiToken, azione, userSubscriptions)
      .then((response) => {
        setLoading(false);
        if (response.data) {
          setFileB64(response.data);
          setShowModalFile(true);
        } else window.location.reload();
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  };

  const [otherService, setOtherService] = useState([]);

  const bodyFile = () => {
    return (
      <object
        width="100%"
        height="900"
        data={fileB64 ? `data:application/pdf;base64,${fileB64}` : undefined}
        type="application/pdf"
      ></object>
    );
  };

  const handleCloseModalFile = () => {
    window.location.reload();
  };

  useEffect(() => {
    if (firstTime && userSubscriptions?.dettagli) {
      setDettaglio(userSubscriptions.dettagli);
    } else {
      setDettaglio(`
  <p style="text-align:center;">SPORTELLO PUA</p>
  <p style="text-align:center;">Relazione </p>
  <p style="text-align:right;">${cookies.user_profile.AreaName},</p>
  <p style="text-align:right;">Assistente Sociale</p>
  `);
    }
    setFirstTime(false);
  }, [userSubscriptions]);

  useEffect(() => {
    if (firstTime2 && userSubscriptions?.otherServices) {
      setOtherService(
        userSubscriptions?.otherServices
          ? userSubscriptions?.otherServices?.split("/;/")
          : []
      );
    }
    setFirstTime2(false);
  }, [userSubscriptions?.otherServices]);

  return (
    <>
      <div className="container mb-5">
        <div className="row">
          <div className="col-lg-12">
            {" "}
            <div className="col-lg-12 mt-3">
              <div className="card-wrapper card-space">
                <div className="card card-bg no-after card-big roundedCustom">
                  <div className="card-body">
                    {userSubscriptions?.state === "ADDED" && (
                      <>
                        {userSubscriptions &&
                        !(
                          userSubscriptions.subscriptionFiles.filter(
                            (x) =>
                              x.description === "fileDaFirmare" ||
                              "condizioneSanitaria"
                          ).length > 1
                        ) ? (
                          <div className="alert alert-info mt-2">
                            In Attesa della relazione e della valutazione
                            sanitaria in carico all'operatore PUA.
                          </div>
                        ) : (
                          <>
                            {!(
                              userSubscriptions.subscriptionFiles.filter(
                                (x) => x.description === "condizioneSociale"
                              ).length > 0
                            ) ? (
                              <div className="alert alert-info mt-2">
                                In Attesa della valutazione sociale in carico
                                all'operatore.
                              </div>
                            ) : (
                              <>
                                {!(userSubscriptions?.orePreviste > 0) &&
                                !(
                                  userSubscriptions.subscriptionFiles.filter(
                                    (x) => x.description === "svamaFile"
                                  ).length > 0
                                ) ? (
                                  <div className="alert alert-info mt-2">
                                    In Attesa della svama e delle ore previste
                                    dall'equipe in carico all'operatore PUA.
                                  </div>
                                ) : (
                                  <></>
                                )}
                              </>
                            )}
                          </>
                        )}
                      </>
                    )}
                    {userSubscriptions?.state === "LOADED" && (
                      <>
                        {isOperator ? (
                          <div className="row align-items-center justify-content-center">
                            <button
                              type="button"
                              className="btn btn-primary text-success w-50 p-2 py-3 mb-4"
                              onClick={() => {
                                setshowModalModify(true);
                              }}
                            >
                              <svg className="icon icon-white">
                                <use href={`${iconSprite}#it-pencil`} />
                              </svg>{" "}
                              <span className="align-middle text-white">
                                Presa in Carico
                              </span>
                            </button>
                          </div>
                        ) : (
                          <div className="alert alert-info mt-2">
                            In Attesa di revisione da parte dell'Ufficio di
                            Piano
                          </div>
                        )}
                      </>
                    )}
                    {userSubscriptions?.state === "VALIDATED" && (
                      <div className="alert alert-success mt-2">
                        <div className="row">
                          <strong>Validato</strong>
                        </div>
                        <div className="row">
                          {userSubscriptions?.orePreviste && (
                            <div className="col-2">
                              Ore previste:{" "}
                              <strong className="ml-1">
                                {userSubscriptions?.orePreviste}
                              </strong>
                            </div>
                          )}
                          {userSubscriptions?.dataInizio && (
                            <div className="col-5">
                              Periodo di validità: dal
                              <strong className="mx-1">
                                {userSubscriptions?.dataInizio}
                              </strong>
                              {userSubscriptions?.dataFine && (
                                <>
                                  al
                                  <strong className="ml-1">
                                    {userSubscriptions?.dataFine}
                                  </strong>
                                </>
                              )}
                            </div>
                          )}
                          {userSubscriptions?.nProtocollo && (
                            <div className="col-2">
                              N. Protocollo:{" "}
                              <strong className="ml-1">
                                {userSubscriptions?.nProtocollo}
                              </strong>
                            </div>
                          )}
                          {userSubscriptions?.nProtocolloUscita && (
                            <div className="col-3">
                              N. Protocollo Uscita:{" "}
                              <strong className="ml-1">
                                {userSubscriptions?.nProtocolloUscita}
                              </strong>
                            </div>
                          )}
                          <div className="col text-right">
                            <button
                              type="button"
                              className="btn btn-outline-primary text-success  p-2"
                              onClick={() => {
                                setshowModalModify(true);
                              }}
                              title="Modifica iscrizione"
                            >
                              <svg className="icon icon-primary">
                                <use href={`${iconSprite}#it-pencil`} />
                              </svg>
                            </button>
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="row row-cols-2">
                      <div className="col mt-4">
                        {userSubscriptions &&
                        userSubscriptions.subscriptionFiles.filter(
                          (x) => x.description === "fileDaFirmare"
                        ).length > 0 ? (
                          <>
                            {userSubscriptions.subscriptionFiles
                              .filter((x) => x.description === "fileDaFirmare")
                              .map((allegato, index) => (
                                <>
                                  <div
                                    className="col text-center border-right"
                                    key={index}
                                  >
                                    <h4>Relazione dell'operatore PUA</h4>
                                    <div className="categoryicon-top">
                                      <span className="text">
                                        <a
                                          href="#"
                                          className="text-decoration-none font-weight-bold"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            setFile({
                                              data:
                                                "data:application/pdf;base64," +
                                                allegato?.storageFile?.file,
                                            });
                                            toggleModalShowFile(true);
                                          }}
                                        >
                                          <svg className="icon">
                                            <use
                                              href={`${iconSprite}#it-clip`}
                                            ></use>
                                          </svg>
                                          {allegato.storageFile.name}
                                        </a>

                                        <br />
                                      </span>
                                    </div>
                                  </div>
                                </>
                              ))}
                          </>
                        ) : (
                          <div className="alert alert-info mt-2">
                            Relazione non ancora creata
                          </div>
                        )}
                      </div>
                      <div className="col text-center mt-4">
                        <h4>Valutazione sanitaria</h4>
                        {userSubscriptions.subscriptionFiles.filter(
                          (x) => x.description === "condizioneSanitaria"
                        ).length > 0 ? (
                          <>
                            {userSubscriptions.subscriptionFiles
                              .filter(
                                (x) => x.description === "condizioneSanitaria"
                              )
                              .map((allegatoFirmato, index) => (
                                <div className="col" key={index}>
                                  <div className="row">
                                    <div className="col-11">
                                      <div className="categoryicon-top">
                                        <span className="text">
                                          <a
                                            href="#"
                                            className="text-decoration-none font-weight-bold"
                                            onClick={(e) => {
                                              e.preventDefault();
                                              setFile({
                                                data:
                                                  "data:application/pdf;base64," +
                                                  allegatoFirmato?.storageFile
                                                    ?.file,
                                              });
                                              toggleModalShowFile(true);
                                            }}
                                          >
                                            <svg className="icon">
                                              <use
                                                href={`${iconSprite}#it-clip`}
                                              ></use>
                                            </svg>
                                            {allegatoFirmato.storageFile.name}
                                          </a>

                                          <br />
                                        </span>
                                      </div>
                                    </div>
                                    <div className="col-1">
                                      <button
                                        type="button"
                                        className={
                                          userSubscriptions?.state === "VALIDATED"
                                            ? "border btn btn-outline-primary text-success  p-2"
                                            : "btn btn-outline-primary text-success  p-2"
                                        }
                                        onClick={() => {
                                          toggleModalAdd(true);
                                          setFileSettings({
                                            title:
                                              "Carica valutazione sanitaria",
                                            description: "condizioneSanitaria",
                                            fileName: "Condizione_Sanitaria",
                                          });
                                        }}
                                        aria-label="Carica valutazione sanitaria"
                                        disabled={userSubscriptions?.state === "VALIDATED"}
                                        title={
                                          userSubscriptions?.state === "VALIDATED"
                                            ? "Non si possono apportare modifiche alle iscrizioni validate"
                                            : "Sovrascrivi valutazione sanitaria"
                                        }
                                      >
                                        <svg className="icon icon-primary">
                                          <use
                                            href={`${iconSprite}#it-upload`}
                                          />
                                        </svg>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              ))}
                          </>
                        ) : isDelegate ? (
                          <div className="col align-self-center text-center">
                            <button
                              type="button"
                              className="btn btn-outline-secondary border p-2"
                              isDisabled
                              title="Questa operazione non è consentita"
                            >
                              <svg className="icon icon-secondary">
                                <use href={`${iconSprite}#it-upload`} />
                              </svg>{" "}
                              <span className="align-middle">
                                Carica valutazione sanitaria
                              </span>
                            </button>
                          </div>
                        ) : (
                          <div className="col align-self-center text-center">
                            <button
                              type="button"
                              className={
                                userSubscriptions?.state === "VALIDATED"
                                  ? "border btn btn-outline-primary text-success mt-2 p-2"
                                  : "btn btn-outline-primary text-success mt-2 p-2"
                              }
                              onClick={() => {
                                toggleModalAdd(true);
                                setFileSettings({
                                  title: "Valutazione Sanitaria",
                                  description: "condizioneSanitaria",
                                  fileName: "Condizione_Sanitaria",
                                });
                              }}
                              disabled={userSubscriptions?.state === "VALIDATED"}
                              title={
                                userSubscriptions?.state === "VALIDATED"
                                  ? "Non si possono apportare modifiche alle iscrizioni validate"
                                  : "Carica valutazione sanitaria"
                              }
                            >
                              <svg className="icon icon-primary">
                                <use href={`${iconSprite}#it-upload`} />
                              </svg>{" "}
                              <span className="align-middle">
                                Carica valutazione sanitaria
                              </span>
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                    {!isDelegate && (
                      <>
                        <div className="wrapper">
                          {!firstTime && (
                            <EditorJs
                              editorTemp={dettaglio}
                              setEditorTemp={setDettaglio}
                            />
                          )}
                        </div>{" "}
                        <div className="row mt-4">
                          <div className="col-6">
                            {!userSubscriptions.subscriptionFiles.filter(
                              (x) => x.description === "fileDaFirmare"
                            ).length > 0 && (
                              <div className="alert alert-warning col-12">
                                Relazione non ancora ufficializzata
                              </div>
                            )}
                          </div>
                          <div className="col-6 d-flex justify-content-end mb-4">
                            <button
                              type="button"
                              className="btn btn-outline-primary mr-2"
                              onClick={() => handleSave("0")}
                            >
                              <svg className="icon icon-secondary mr-1">
                                <use href={`${iconSprite}#it-pencil`} />
                              </svg>
                              Salva bozza
                            </button>
                            <button
                              type="button"
                              className="btn btn-success"
                              onClick={() => setShowModalConfirm(true)}
                            >
                              <svg className="icon icon-white mr-1">
                                <use href={`${iconSprite}#it-file`} />
                              </svg>
                              Ufficializza e crea PDF
                            </button>
                          </div>
                        </div>
                      </>
                    )}
                    {userSubscriptions &&
                      userSubscriptions.subscriptionFiles.filter(
                        (x) =>
                          x.description === "fileDaFirmare" ||
                          x.description === "condizioneSanitaria"
                      ).length > 1 && (
                        <>
                          {!haveIsee ? (
                            <div className="alert alert-warning" role="alert">
                              <strong>Attenzione!</strong> Nessun ISEE valido
                              trovato.
                              <br />
                              Per poter procedere con l’intervento è necessario
                              inserire prima un ISEE valido tramite la{" "}
                              <Link
                                to={`/lista_utenti/cartella_sociale?id=${userSubscriptions.user.id}`}
                                className="alert-link"
                              >
                                cartella sociale
                              </Link>
                              .
                            </div>
                          ) : (
                            <div className="container mb-5">
                              <div className="row mt-4">
                                <div className="col-6 text-center border-right">
                                  <h4>Valutazione sociale</h4>
                                  {userSubscriptions.subscriptionFiles.filter(
                                    (x) => x.description === "condizioneSociale"
                                  ).length > 0 ? (
                                    <>
                                      {userSubscriptions.subscriptionFiles
                                        .filter(
                                          (x) =>
                                            x.description ===
                                            "condizioneSociale"
                                        )
                                        .map((allegatoFirmato, index) => (
                                          <div className="col" key={index}>
                                            <div className="row">
                                              <div className="col-10">
                                                <div className="categoryicon-top">
                                                  <span className="text">
                                                    <a
                                                      href="#"
                                                      className="text-decoration-none font-weight-bold"
                                                      onClick={(e) => {
                                                        e.preventDefault();
                                                        setFile({
                                                          data:
                                                            "data:application/pdf;base64," +
                                                            allegatoFirmato
                                                              ?.storageFile
                                                              ?.file,
                                                        });
                                                        toggleModalShowFile(
                                                          true
                                                        );
                                                      }}
                                                    >
                                                      <svg className="icon">
                                                        <use
                                                          href={`${iconSprite}#it-clip`}
                                                        ></use>
                                                      </svg>
                                                      {
                                                        allegatoFirmato
                                                          .storageFile.name
                                                      }
                                                    </a>

                                                    <br />
                                                  </span>
                                                </div>
                                              </div>
                                              <div className="col-2 pl-4">
                                                <button
                                                  type="button"
                                                  className={
                                                    userSubscriptions?.state === "VALIDATED"
                                                      ? "border btn btn-outline-primary text-success  p-2"
                                                      : "btn btn-outline-primary text-success  p-2"
                                                  }
                                                  onClick={() => {
                                                    toggleModalAdd(true);
                                                    setFileSettings({
                                                      title:
                                                        "Carica Valutazione Sociale",
                                                      description:
                                                        "condizioneSociale",
                                                      fileName:
                                                        "Condizione_Sociale",
                                                    });
                                                  }}
                                                  aria-label="Carica valutazione sociale"
                                                  disabled={userSubscriptions?.state === "VALIDATED"}
                                                  title={
                                                    userSubscriptions?.state === "VALIDATED"
                                                      ? "Non si possono apportare modifiche alle iscrizioni validate"
                                                      : "Sovrascrivi valutazione sociale"
                                                  }
                                                >
                                                  <svg className="icon icon-primary">
                                                    <use
                                                      href={`${iconSprite}#it-upload`}
                                                    />
                                                  </svg>
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                        ))}
                                    </>
                                  ) : isExecutive ? (
                                    <div className="col align-self-center text-center">
                                      <button
                                        type="button"
                                        className="btn btn-outline-secondary border p-2"
                                        isDisabled
                                        title="Questa operazione non è consentita"
                                      >
                                        <svg className="icon icon-secondary">
                                          <use
                                            href={`${iconSprite}#it-upload`}
                                          />
                                        </svg>{" "}
                                        <span className="align-middle">
                                          Carica valutazione sociale
                                        </span>
                                      </button>
                                    </div>
                                  ) : (
                                    <div className="col align-self-center text-center">
                                      <button
                                        type="button"
                                        className={
                                          userSubscriptions?.state === "VALIDATED"
                                            ? "border btn btn-outline-primary text-success  p-2"
                                            : "btn btn-outline-primary text-success  p-2"
                                        }
                                        onClick={() => {
                                          toggleModalAdd(true);
                                          setFileSettings({
                                            title: "Valutazione Sociale",
                                            description: "condizioneSociale",
                                            fileName: "Condizione_Sociale",
                                          });
                                        }}
                                        disabled={userSubscriptions?.state === "VALIDATED"}
                                        title={
                                          userSubscriptions?.state === "VALIDATED"
                                            ? "Non si possono apportare modifiche alle iscrizioni validate"
                                            : "Carica valutazione sociale"
                                        }
                                      >
                                        <svg className="icon icon-primary">
                                          <use
                                            href={`${iconSprite}#it-upload`}
                                          />
                                        </svg>{" "}
                                        <span className="align-middle">
                                          Carica valutazione sociale
                                        </span>
                                      </button>
                                    </div>
                                  )}
                                </div>
                                <div className="col-6 text-center">
                                  <h4>Altre misure di sostegno:</h4>
                                  <div className="row">
                                    <div className="col-11">
                                      {otherService?.length > 0 ? (
                                        <ul>
                                          <div className="row">
                                            {otherService.map(
                                              (service, index) => (
                                                <li
                                                  key={index}
                                                  className="col-12 text-left"
                                                >
                                                  {service}
                                                </li>
                                              )
                                            )}
                                          </div>
                                        </ul>
                                      ) : (
                                        <div>
                                          Nessuna misura di sostegno presente
                                        </div>
                                      )}
                                    </div>
                                    <div className="col-1">
                                      <button
                                        type="button"
                                        className={
                                          userSubscriptions?.state === "VALIDATED"
                                            ? "border btn btn-outline-primary text-success  p-2"
                                            : "btn btn-outline-primary text-success  p-2"
                                        }
                                        onClick={() => {
                                          setShowModalOtherServices(true);
                                        }}
                                        disabled={userSubscriptions?.state === "VALIDATED"}
                                        title={
                                          userSubscriptions?.state === "VALIDATED"
                                            ? "Non si possono apportare modifiche alle iscrizioni validate"
                                            : "Modifica le misure di sostegno di cui il richiedente beneficia"
                                        }
                                      >
                                        <svg className="icon icon-primary">
                                          <use
                                            href={`${iconSprite}#it-pencil`}
                                          />
                                        </svg>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </>
                      )}
                    {userSubscriptions.subscriptionFiles.filter(
                      (x) => x.description === "condizioneSociale"
                    ).length > 0 && (
                      <>
                        <div className="container mb-5">
                          <div className="row row-cols-2">
                            <div className="col mt-4 text-center border-right">
                              <h4>SVAMA</h4>
                              {userSubscriptions.subscriptionFiles.filter(
                                (x) => x.description === "svamaFile"
                              ).length > 0 ? (
                                <>
                                  {userSubscriptions.subscriptionFiles
                                    .filter(
                                      (x) => x.description === "svamaFile"
                                    )
                                    .map((allegatoFirmato, index) => (
                                      <div className="col" key={index}>
                                        <div className="row">
                                          <div className="col-10">
                                            <div className="categoryicon-top">
                                              <span className="text">
                                                <a
                                                  href="#"
                                                  className="text-decoration-none font-weight-bold"
                                                  onClick={(e) => {
                                                    e.preventDefault();
                                                    setFile({
                                                      data:
                                                        "data:application/pdf;base64," +
                                                        allegatoFirmato
                                                          ?.storageFile?.file,
                                                    });
                                                    toggleModalShowFile(true);
                                                  }}
                                                >
                                                  <svg className="icon">
                                                    <use
                                                      href={`${iconSprite}#it-clip`}
                                                    ></use>
                                                  </svg>
                                                  {
                                                    allegatoFirmato.storageFile
                                                      .name
                                                  }
                                                </a>

                                                <br />
                                              </span>
                                            </div>
                                          </div>
                                          <div className="col-2 pl-4">
                                            <button
                                              type="button"
                                              className={
                                                userSubscriptions?.state === "VALIDATED"
                                                  ? "border btn btn-outline-primary text-success  p-2"
                                                  : "btn btn-outline-primary text-success  p-2"
                                              }
                                              onClick={() => {
                                                toggleModalAdd(true);
                                                setFileSettings({
                                                  title: "SVAMA",
                                                  description: "svamaFile",
                                                  fileName: "SVAMA",
                                                });
                                              }}
                                              aria-label="Carica SVAMA"
                                              disabled={userSubscriptions?.state === "VALIDATED"}
                                              title={
                                                userSubscriptions?.state === "VALIDATED"
                                                  ? "Non si possono apportare modifiche alle iscrizioni validate"
                                                  : "Sovrascrivi SVAMA"
                                              }
                                            >
                                              <svg className="icon icon-primary">
                                                <use
                                                  href={`${iconSprite}#it-upload`}
                                                />
                                              </svg>
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                </>
                              ) : isDelegate ? (
                                <div className="col align-self-center text-center">
                                  <button
                                    type="button"
                                    className="btn btn-outline-secondary border p-2"
                                    isDisabled
                                    title="Questa operazione non è consentita"
                                  >
                                    <svg className="icon icon-secondary">
                                      <use href={`${iconSprite}#it-upload`} />
                                    </svg>{" "}
                                    <span className="align-middle">
                                      Carica SVAMA
                                    </span>
                                  </button>
                                </div>
                              ) : (
                                <div className="col align-self-center text-center">
                                  <button
                                    type="button"
                                    className={
                                      userSubscriptions?.state === "VALIDATED"
                                        ? "border btn btn-outline-primary text-success p-2"
                                        : "btn btn-outline-primary text-success p-2"
                                    }
                                    onClick={() => {
                                      toggleModalAdd(true);
                                      setFileSettings({
                                        title: "SVAMA",
                                        description: "svamaFile",
                                        fileName: "SVAMA",
                                      });
                                    }}
                                    disabled={userSubscriptions?.state === "VALIDATED"}
                                    title={
                                      userSubscriptions?.state === "VALIDATED"
                                        ? "Non si possono apportare modifiche alle iscrizioni validate"
                                        : "Carica SVAMA"
                                    }
                                  >
                                    <svg className="icon icon-primary">
                                      <use href={`${iconSprite}#it-upload`} />
                                    </svg>{" "}
                                    <span className="align-middle">
                                      Carica SVAMA
                                    </span>
                                  </button>
                                </div>
                              )}
                            </div>
                            <div className="col text-center mt-4">
                              <h4>Ore stabilite dall’equipe medica</h4>
                              <div className="row">
                                <div className="col-11 text-center">
                                  <div className="row">
                                    <div className="col-4"></div>
                                    <div className="col-5 mt-2">
                                      <Input
                                        id="orePreviste"
                                        disabled
                                        label="Ore previste"
                                        type="text"
                                        value={userSubscriptions.orePreviste}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-1 mt-2">
                                  {isDelegate ? (
                                    <button
                                      type="button"
                                      className="btn btn-outline-primary text-success  p-2"
                                      isDisabled
                                      title="Operazione in carico al personale PUA"
                                    >
                                      <svg className="icon icon-primary">
                                        <use href={`${iconSprite}#it-pencil`} />
                                      </svg>
                                    </button>
                                  ) : (
                                    <button
                                      type="button"
                                      className={
                                        userSubscriptions?.state === "VALIDATED"
                                          ? "border btn btn-outline-primary text-success  p-2"
                                          : "btn btn-outline-primary text-success  p-2"
                                      }
                                      onClick={() => {
                                        toggleModalAddHours(true);
                                      }}
                                      disabled={userSubscriptions?.state === "VALIDATED"}
                                      title={
                                        userSubscriptions?.state === "VALIDATED"
                                          ? "Non si possono apportare modifiche alle iscrizioni validate"
                                          : "Modifica ore stabilite dell'equipe medica"
                                      }
                                    >
                                      <svg className="icon icon-primary">
                                        <use href={`${iconSprite}#it-pencil`} />
                                      </svg>
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalComponent
        toggleModal={setShowModalFile}
        isOpen={showModalFile}
        header="Crea PDF Relazione"
        body={bodyFile()}
        buttonDeny="Chiudi"
        onClose={handleCloseModalFile}
      />
      <ModalComponent
        toggleModal={setShowModalConfirm}
        isOpen={showModalConfirm}
        header="Conferma Operazione di Ufficializzazione"
        body="Vuoi davvero ufficializzare la relazione? Una volta confermato, verrà generato e protocollato un file."
        buttonDeny="Chiudi"
        buttonConfirm="Conferma"
        function={() => (handleSave("3"), setShowModalConfirm(false))}
      />
      {loading && <Loader></Loader>}
    </>
  );
}

export default SubscriptionDetailADI;
